import { createContext, useContext, useEffect, useState } from "react";
import fr from "./fr";
import ar from "./ar";

const translations = { fr, ar };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(
    localStorage.getItem("hana_lang") || "fr"
  );

  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split(".");
    let result = translations[language];
    for (const k of keys) {
      if (result && typeof result === "object") {
        result = result[k];
      } else {
        return key;
      }
    }
    return result === undefined || result === null ? key : result;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("hana_lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, isRTL: language === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
